export default __webpack_public_path__ + "static/media/LexendDeca-Bold.6ed4c95e.ttf";